import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

async function getVersionAPI() {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/version`;
}

export async function getVersion() {
  const url = await getVersionAPI();

  const res: AxiosResponse = await axios
    .get(`${url}`, {
      headers: {
        Accept: '*/*',
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  const status = res.status == 201 || res.status == 200;
  return [status, status ? res.data.versionInfo : res.status];
}
